<template>
  <div>
    <div class="box">
      <p class="return" @click="back">返回首页</p>
      <span class="line">|</span>
      <p class="contract">系统设置</p>
      <span class="lines">></span>
      
      <p class="contract back" @click="$router.go(-1)" v-if="$route.query.flag && $route.query.flag==7">组织管理</p>
      <p class="contract back" @click="$router.go(-1)" v-else>账号管理</p>

      <span class="lines">></span>
      <p class="contract">创建账号</p>
    </div>
    <div class="p_btn">
      <div>
        <div class="mainTitle" v-if="!edit">创建账号</div>
        <div class="mainTitle" v-if="edit">编辑账号</div>
      </div>
    </div>

    <div class="dataitems" v-if="!edit">
      <el-form
        label-width="100px"
        ref="baseInfo"
        :rules="rules"
        :model="baseInfo"
        label-position="right"
      >
        <div class="item">
          <el-form-item label="姓名" prop="name">
            <el-input v-model.trim="baseInfo.name" maxlength="10"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model.trim="baseInfo.mobile" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model.trim="baseInfo.email"></el-input>
          </el-form-item>
          <el-form-item label="部门" prop="orgId" haveto="true">
            <el-treeselect
              v-model="baseInfo.orgId"
              placeholder="请选择"
              :data="orgList"
              :props="propsbew"
              :search="false"
              style="width:437px"
            ></el-treeselect>

            <!-- <el-select
              style="width: 455px"
              v-model="baseInfo.orgId"
              placeholder="请选择"
            >
              <el-option
                :label="v.name"
                :value="v.id"
                v-for="(v, k) in orgList"
                :key="k"
              ></el-option>
            </el-select> -->
          </el-form-item>
          <!-- <el-form-item label="权限">
                        <el-radio-group v-model="baseInfo.authority">
                            <el-radio :label="true">选择权限组</el-radio>
                            <el-radio :label="false">直接设置权限</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="baseInfo.authority==true" label="权限组" haveto="true" prop="accountGroup">
                        <el-select v-model="baseInfo.accountGroup" placeholder="请选择权限组">
                            <el-option :label="v.name" :value="v.id" v-for="(v,k) in accountGroup" :key="k"></el-option>
                        </el-select>
                    </el-form-item> -->
        </div>
      </el-form>
    </div>
    <div class="dataitems" v-if="edit">
      <el-form
        label-width="100px"
        ref="editInfo"
        :rules="rules"
        :model="editInfo"
        label-position="right"
      >
        <div class="item">
          <el-form-item label="姓名：">
            {{ editInfo.name }}
          </el-form-item>
          <el-form-item label="手机号：">
            {{ editInfo.mobile }}
          </el-form-item>
          <el-form-item label="邮箱：">
            {{ editInfo.email }}
          </el-form-item>
          <el-form-item label="部门" prop="orgId">
            <el-treeselect
              v-model="editInfo.orgId"
              placeholder="请选择"
              :data="orgList"
              :props="propsbew"
              :search="false"
            ></el-treeselect>

            <!-- <el-select v-model="editInfo.orgId" placeholder="请选择">
              <el-option
                :label="v.name"
                :value="v.id"
                v-for="(v, k) in orgList"
                :key="k"
              ></el-option>
            </el-select> -->
          </el-form-item>
          <!-- <el-form-item label="权限">
                        <el-radio-group v-model="editInfo.authority">
                            <el-radio :label="true">选择权限组</el-radio>
                            <el-radio :label="false">直接设置权限</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="editInfo.authority==true" label="权限组" haveto="true" prop="accountGroup">
                        <el-select v-model="editInfo.accountGroup" placeholder="请选择权限组">
                            <el-option :label="v.name" :value="v.id" v-for="(v,k) in accountGroup" :key="k"></el-option>
                        </el-select>
                    </el-form-item> -->
        </div>
      </el-form>
    </div>
    <!-- <div v-if="editInfo.authority==false||baseInfo.authority==false" class="contree">
            <div class="trees">
                <div class="table">
                    <h4>页面权限</h4>
                </div>

                <div class='mytree'>
                    <div class='first'>嗖嗖人力服务平台</div>

                    <el-tree
                            ref="tree"
                            :default-checked-keys="defaultLists"
                            :default-expanded-keys="defaultLists"
                            :props="propsa"
                            :data="data"
                            :indent='0'
                            node-key="id"
                            @check="checkAllTree"
                            show-checkbox
                            @node-click="handleCheckon"
                            @check-change="handleCheckChange">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                 <span>
              <i v-if='data.type==1'>
	        <img src="../../../assets/img/shezhi.png"></img>
                
              </i>
               <i v-if='data.type==2'>
	        <img src="../../../assets/img/shezhi1.png"></img>
                
              </i>
             <!-- <i v-if='data.type==3'>-->
    <!-- <img v-if='chonse==false && data.id == checkIdTrees' src="../../../assets/img/onePage.png"></img>-->
    <!--  <img v-else src="../../../assets/img/hourPage.png"></img>-->
    <!-- </i>-->
    <!-- {{data.name}}
                 </span>              
           </span>
                    </el-tree>

                </div>

            </div>
            <div class="edit">
                <div class="table">
                    <h4>操作权限</h4>
                </div>
                <div class="edut">
                    <div class="fontName">{{operationName}}</div>
                    <el-checkbox-group v-model="checkOne" class="checkGroup">
                        <el-checkbox v-for="(v,k) in operation"
                                     :label="v.id"
                                     :key="k"
                                     @change="handleCheckedCitiesChange($event,v.id,checkOne)">
                            {{v.name}}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>


            </div> -->

    <!-- </div> -->
    <div class="btndiv">
      <button class="btn" type="button" @click="$router.go(-1)" tag="button">
        取消
      </button>
      <button class="btn subbtn" @click="addOrg" type="button">保存</button>
    </div>
  </div>
</template>

<script>
import treeTable from "@/components/common/TreeTable";
import groupBtn from "@/components/common/groupBtnPermission";

export default {
  created() {
    this.edit = this.$route.query.edit;
    //初始化数据
    // this.loadData();
    this.loadDataPandO();
    this.loadaddCount();
    if (this.$route.query.id) {
      this.loadEiditPermission();
    }
  },
  data() {
    return {
      propsbew: {
        label: "name",
        value: "id",
        children: "childs",
      },
      operationIds: [],
      singleIds: [],
      checkIdTrees: "",
      checkk: [],
      detailList: [],
      chonse: false,
      codes: "",
      checks: false,
      listidss: [],
      choseYes: false,
      defaultLists: [],
      listIds: [],
      actionid: "",
      operationName: "",
      permissionList: [],
      operation: [],
      checkOne: [],
      data: [],
      editInfo: {},
      propsa: {
        label: "name",
        value: "id",
        children: "children",
      },
      props: {
        label: "label",
        value: "id",
        children: "children",
      },
      edit: false,
      orgList: [],
      baseInfo: {
        name: "",
        mobile: "",
        email: "",
        orgId: "",
        authority: true,
        accountGroup: "",
      },
      accountGroup: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
          },
        ],
        orgId: [
          {
            required: true,
            message: "请选择部门",
            trigger: "change",
          },
        ],
        accountGroup: [
          {
            required: true,
            message: "请选择权限组",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    back() {
      this.$router.push({ path: "/main" });
    },
    checkAllTree(data, list) {
      this.checkIdTrees = data.id;
      this.choseYes = true;
      // this.listIds = list.checkedNodes

      let parentArr = this.$refs.tree.getHalfCheckedKeys();
      let childeArr = this.$refs.tree.getCheckedKeys();
      let arr = childeArr.concat(parentArr);
      this.listIds = arr;
    },

    detailTrees(data, values) {
      // let detailList = []
      for (var key in data) {
        if (data[key].children.length > 0) {
          this.detailTrees(data[key].children, values);
        } else {
          this.detailList.push(data[key].id);
        }
      }
      let arr = [];

      for (let j of this.detailList) {
        for (let i of values) {
          if (i == j) {
            arr.push(+i);
          }
        }
      }
      this.permissionList = values;
      this.defaultLists = arr;
    },

    loadEiditPermission() {
      const params = {
        userId: this.$route.query.id,
      };
      return this.$axios
        .get("/userInfo/queryUserInfo", {
          params,
        })
        .then((res) => {
          if (res.data.status == 1) {
            if (res.data.data.permissionGroupId) {
              this.$set(this.editInfo, "authority", true);
            } else {
              this.$set(this.editInfo, "authority", false);
              this.permissionList = res.data.data.permissionList;
              this.detailTrees(this.data, res.data.data.permissionList);
            }
            this.editInfo = {
              mobile: res.data.data.mobile,
              name: res.data.data.name,
              email: res.data.data.email,
              orgId: res.data.data.orgId,
              authority: this.editInfo.authority,
              accountGroup: res.data.data.permissionGroupId,
            };
          }
        });
    },

    //保存

    addOrg() {
      this.listidss = [];
      if (this.choseYes == true || this.checks == true) {
        let parentArr = this.$refs.tree.getHalfCheckedKeys();
        let childeArr = this.$refs.tree.getCheckedKeys();
        let arr = childeArr.concat(parentArr);
        this.listIds = arr;
        if (this.listIds.length > 0) {
          for (let i of this.listIds) {
            this.listidss.push(i);
          }
        } else if (this.listIds.length == 0) {
          this.listidss == [];
        } else {
          for (let i of this.defaultLists.values()) {
            this.listidss.push(i);
          }
        }
        for (let j of this.checkOne.values()) {
          this.listidss.push(j);
        }
      } else {
        this.listidss = this.permissionList;
      }
      if (!this.edit) {
        this.$refs.baseInfo.validate((status) => {
          if (status == true) {
            if (this.baseInfo.authority == false) {
              this.baseInfo.accountGroup = "";
            } else if (this.baseInfo.authority == true) {
              this.permissionList = [];
            }
            return this.$axios
              .post(
                "userInfo/createServerUser?name=" +
                  this.baseInfo.name +
                  "&mobile=" +
                  this.baseInfo.mobile +
                  "&email=" +
                  this.baseInfo.email +
                  "&orgId=" +
                  this.baseInfo.orgId +
                  "&permissionGroupId=" +
                  this.baseInfo.accountGroup +
                  "&permissionList=" +
                  this.listidss
              )
              .then((res) => {
                if (res.data.status == 1) {
                  this.$message.success(res.data.message);
                  this.$router.push({ path: "/main/system/system/account" });
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                //处理错误
                console.error(err);
              });
          }
        });
      } else if (this.edit) {
        this.$refs.editInfo.validate((status) => {
          if (status == true) {
            if (this.editInfo.authority == false) {
              this.editInfo.accountGroup = "";
            } else if (this.editInfo.authority == true) {
              this.listidss = [];
            }

            // '&permissionList=' + this.listidss + '&permissionGroupId=' + this.editInfo.accountGroup +
            return this.$axios
              .post(
                "userInfo/updateServerUser?name=" +
                  this.editInfo.name +
                  "&mobile=" +
                  this.editInfo.mobile +
                  "&email=" +
                  this.editInfo.email +
                  "&orgId=" +
                  this.editInfo.orgId +
                  "&userId=" +
                  this.$route.query.id
              )
              .then((res) => {
                if (res.data.status == 1) {
                  this.$message.success(res.data.message);
                  if(this.$route.query.flag && this.$route.query.flag== 7){
                  this.$router.push({ path: "/main/system/system/orgManage" });

                  }else {
                    this.$router.push({ path: "/main/system/system/account" });

                  }
                } else {
                  this.$message.error(res.data.message);
                }
              })
              .catch((err) => {
                //处理错误
                this.maskshow = false;
                console.error(err);
              });
          }
        });
      }
    },

    loadaddCount() {
      this.$axios
        .get("/permissionGroup/findPermissionGroups")
        .then((res) => {
          if (res.data.status === 1) {
            this.accountGroup = res.data.data;
          } else {
            this.$message.error("查询权限组请求失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    handleCheckChange(data, checked, indeterminate) {},
    handleNodeClick(data) {},
    handleCheckedCitiesChange(data, id, ids) {
      if (ids == this.operationIds) {
        this.chonse = true;
      } else {
        this.chonse = false;
      }
    },
    handleCheckon(data) {
      this.operationName = data.name;
      this.checks = true;
      //查询某一个权限
      this.$axios
        .get("/permission/findByParentId?parentId=" + data.id)
        .then((res) => {
          if (res.data.status === 1) {
            this.operation = res.data.data;
            this.operationIds = [];
            for (var i = 0; i < this.operation.length; i++) {
              this.operationIds.push(this.operation[i].id);
            }

            for (var i = 0; i < this.permissionList.length; i++) {
              for (var j = 0; j < this.operation.length; j++) {
                if (this.permissionList[i] == this.operation[j].id) {
                  this.checkk = [];
                  this.checkk.push(this.permissionList[i]);
                  this.checkOne.push(+this.permissionList[i]);
                }
              }
            }
          } else {
            this.$message.error("查询组织列表请求失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    loadDataPandO() {
      //查询组织列表
      this.$axios
        .get("/org/getOrgList")
        .then((res) => {
          if (res.data.status === 1) {
            this.orgList = res.data.data;
          } else {
            this.$message.error("查询组织列表请求失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 加载树列表
    loadData() {
      return this.$axios
        .get("permission/getPermissionTree")
        .then((res) => {
          this.data = res.data.data;
          this.total = res.data.data.total;
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
  },
  components: {
    treeTable,
    groupBtn,
  },
};
</script>

<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style scoped lang="less">
.box {
  display: flex;
  margin-top: 20px;

  .return {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 105, 227, 1);
    margin-right: 20px;
    cursor: pointer;
  }

  .line {
    margin-right: 20px;
    color: #606266;
  }

  .lines {
    margin-right: 20px;
    color: #606266;
    font-weight: bold;
  }

  .back:hover {
    color: #6669e3;
    cursor: pointer;
  }

  .contract {
    margin-right: 20px;

    font-size: 12px;
    font-weight: 400;
    color: rgba(138, 138, 154, 1);
  }
}

.mainTitle {
  font-size: 24px;
  font-weight: bold;
  color: rgba(48, 49, 64, 1);
  margin: 33px 0 14px 0;
}

.dataitems {
  width: 55%;
  // padding-left: 12%;
}

.contree {
  width: 100%;
  height: 740px;
  border-radius: 4px;
  border: 1px solid rgba(216, 218, 225, 1);
  display: flex;
}

.trees {
  width: 50%;
  height: 700px;
  overflow-y: auto;
  overflow-x: hidden;

  border-right: 1px solid #d8dae1;
}

.edit {
  width: 50%;
  height: 740px;
  background: rgba(247, 248, 252, 1);
}

.table {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 20px 34px;

  h4 {
    font-size: 14px;
    font-weight: bold;
    position: relative;
    display: flex;
    align-items: center;
    padding-left: 8px;
    color: #303140;
  }

  h4:before {
    content: "";
    position: absolute;
    left: 0;
    display: block;
    width: 4px;
    height: 12px;
    background-color: #6669e3;
    border-radius: 4px;
  }
}

.gettree {
  margin-left: 34px;
}

.btndiv {
  display: flex;
  justify-content: center;
  margin: 20px 0;

  .subbtn {
    margin-left: 10px;
  }
}

.mytree {
  margin-left: 40px;

  .first {
    margin-left: 10px;
    font-size: 12px;
    font-weight: bold;
    color: rgba(84, 85, 102, 1);
  }
}

.mytree /deep/ .el-tree {
  > .is-current:after {
    background-color: transparent;
  }

  .el-tree > .is-current:after {
    background-color: transparent;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
    background-color: #eee;
  }

  .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉
  .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node :last-child:before {
    height: 38px;
  }

  .el-tree > .el-tree-node:before {
    border-left: none;
  }

  .el-tree > .el-tree-node:after {
    border-top: none;
  }

  .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  .el-tree-node:before {
    border-left: 1px solid #d8dae1;
    bottom: 0px;
    height: 100%;
    top: -17px;
    width: 1px;
  }

  .el-tree-node:after {
    border-top: 1px solid #d8dae1;
    height: 20px;
    top: 21px;
    width: 24px;
  }

  .el-tree .is-current:after {
    background-color: transparent;
  }
}

.edut {
  margin-left: 40px;

  .fontName {
    font-size: 12px;
    font-weight: bold;
    color: rgba(84, 85, 102, 1);
    margin-bottom: 20px;
  }
}
</style>
